import 'hammerjs';

import { environment } from '@env/environment';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { disableConsole } from '@shared/utilities/console.utilities';
import { ZefModule } from './app/zef.module';
import { brandedFavicon } from '@shared/utilities/branding.utilities';
import { initSentry } from '@shared/utilities/sentry.utilities';

initSentry().then(() => {
  if (environment.production) {
    enableProdMode();
    disableConsole();
    brandedFavicon();
  }

  platformBrowser().bootstrapModule(ZefModule, { applicationProviders: [provideZoneChangeDetection()] });
});
